import React, { useState } from "react";

// "HOSTED BY [Q] QUSHi" — the house, as the host of a cash game.
//
// Client (Starting soon cards): "You will see the 'HOSTED BY avatar QUSHi' in
// my stitch design; this is not tied to a profile... Use both of our real logos
// for the circle avatar: our Q and the QUSHi wordmark."
// Client Rev4 (0014888 item 1), for the landing page: "Display the official
// QUSHi Q logo and QUSHi wordmark together as one compact brand lockup. Do not
// display QUSHi as a standard username."
//
// Deliberately NOT game.user.image. A cash game is always run by the house, and
// pointing this at the publishing account would put whoever pressed the button
// in the product — which is exactly the "standard username" treatment the
// client ruled out.
//
// Shared rather than copied: this now renders on the Starting soon card AND on
// the landing page, and the client has already corrected the wordmark once. A
// second copy is a second thing to correct next time.
//
// THE WORDMARK FILE. images/log2.png is what DashboardHeader renders (at
// 84x21), and it is the wordmark ALONE — no Q in it — so it sits beside the
// circle mark without printing a second, blurry Q. /Logo.png is a 329x92
// lockup that does contain the Q, which is why it is not used here.
//
// `size` exists because the two surfaces give the row different room: the
// Starting-soon card has a 16px line box, the landing header is a band of its own.
//
// `onDark` is a THIRD shape rather than a colour swap, because the client asked
// for one: "HOSTED BY QUSHi logo needs to be a little bigger. Remove the circle
// avatar use just the wordmark white logo i provided. The goal is to be able to
// see the 'i'." At 16px the wordmark's green dot — the whole point of the mark —
// was a two-pixel smudge, and the circle beside it was competing with it for the
// same space. So on a dark header there is no circle and the wordmark runs at
// 24px (28px from md), which is where the dot reads.
//
// The Starting-soon card is untouched and keeps its circle: the client's note is
// about the landing page header, and that card is a different surface they have
// already signed off.
// The two grounds this lockup sits on. `onDark` is the teal header; everything
// else is white.
const TONES = {
  dark: { eyebrow: "text-tertiary", fallback: "text-[#0F172A]" },
  light: { eyebrow: "text-white/70", fallback: "text-white" },
};

const SIZES = {
  sm: { dot: "h-5 w-5", mark: "h-3.5", eyebrow: "text-[10px] leading-4", gap: "gap-2" },
  md: { dot: "h-6 w-6", mark: "h-4", eyebrow: "text-[10px] leading-4", gap: "gap-2.5" },
  dark: {
    dot: "",
    mark: "h-6 md:h-7",
    eyebrow: "text-[10px] md:text-[11px] leading-4",
    gap: "gap-2.5 md:gap-3",
  },
};

const HostedByQushi = ({ size = "sm", onDark = false, className = "" }) => {
  const [markBroken, setMarkBroken] = useState(false);
  const [wordmarkBroken, setWordmarkBroken] = useState(false);
  const s = onDark ? SIZES.dark : SIZES[size] || SIZES.sm;
  const tone = onDark ? TONES.light : TONES.dark;

  return (
    <span className={`flex min-w-0 items-center ${s.gap} ${className}`}>
      <span
        className={`shrink-0 ${s.eyebrow} font-bold uppercase tracking-wider ${tone.eyebrow}`}
      >
        Hosted by
      </span>

      {/* No circle on a dark header — the client asked for "just the wordmark".
          Everywhere else the Q avatar stays exactly as it was. */}
      {!onDark && (
        <span
          className={`flex ${s.dot} shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#F3F4F6]`}
        >
          {markBroken ? (
            <span className="text-[9px] font-extrabold text-[#004C50]">Q</span>
          ) : (
            <img
              src="/qushi-mark.png"
              alt=""
              loading="lazy"
              decoding="async"
              className="h-full w-full object-cover"
              onError={() => setMarkBroken(true)}
            />
          )}
        </span>
      )}

      {wordmarkBroken ? (
        <span
          className={`truncate font-montserrat text-xs leading-4 font-bold ${tone.fallback}`}
        >
          QUSHi
        </span>
      ) : (
        <img
          /* The client's file, served from /public rather than bundled: it is
             an asset they hand over and replace, not a source image. */
          src={onDark ? "/Qushi_logo_white_Final.png" : require("../../../images/log2.png")}
          alt="QUSHi"
          className={`${s.mark} w-auto shrink-0`}
          draggable="false"
          onError={() => setWordmarkBroken(true)}
        />
      )}
    </span>
  );
};

export default HostedByQushi;
